angular.module("ainapp")
    .controller("employeeCardController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Employees";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });


                $scope.Employees = [];
                MainService.EmployeesInDropdown().then(function (response) {
                    $scope.Employees = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                })

                $scope.load = 0;

            }
            $scope.Init();

            $scope.Edit = function (data) {
                $state.go("editEmployee", {
                    EmployeeId: data.Id
                });
            }


                }])
